import http from "../http-common";
/* eslint-disable */
class TimelineService {
  timelineList(page, itemPerPage, keyword) {
    return http.get(
      "/timeline/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  getBerita(id) {
    return http.get(`/berita/${id}`, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data, photo) {
    var bodyFormData = new FormData();
    bodyFormData.append("judul", data.judul);
    bodyFormData.append("konten", data.konten);

    if (photo != null) bodyFormData.append("foto", photo);

    return http.post("/berita", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("article", data.article);

    if (data.photo != null) bodyFormData.append("photo", data.photo);

    return http.put(`/timeline/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/timeline/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new TimelineService();
